import arvoreProdutosRoutes from '@/modules/produtos/arvore-produtos/routes'
import comparativoRoutes from '@/modules/produtos/comparativo/routes'

export default [
  {
    path: '/v3/produtos',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [...arvoreProdutosRoutes, ...comparativoRoutes],
  },
]
